import React, { useState } from 'react';
interface Tab {
  id: string;
  label: string;
  content: React.ReactNode;
}
interface TabsProps {
  tabs: Tab[];
  defaultTab?: string;
  onChange?: (tabId: string) => void;
}
export function Tabs({
  tabs,
  defaultTab,
  onChange
}: TabsProps) {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);
  const handleTabChange = (tabId: string) => {
    setActiveTab(tabId);
    onChange?.(tabId);
  };
  const activeTabContent = tabs.find(tab => tab.id === activeTab)?.content;
  return <div className="w-full" data-id="element-640" data-mp="26pakb1xb2za2">
      <div className="flex border-b-2 border-dark-border" role="tablist" data-id="element-641" data-mp="26qlnazixg304">
        {tabs.map(tab => <button key={tab.id} role="tab" aria-selected={activeTab === tab.id} aria-controls={`panel-${tab.id}`} id={`tab-${tab.id}`} onClick={() => handleTabChange(tab.id)} className={`px-6 py-3 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-brand-yellow focus:ring-inset ${activeTab === tab.id ? 'text-brand-yellow border-b-2 border-brand-yellow -mb-0.5' : 'text-gray-400 hover:text-white'}`} data-id="element-642" data-mp="1s1xs4ucztvap">
            {tab.label}
          </button>)}
      </div>
      <div role="tabpanel" id={`panel-${activeTab}`} aria-labelledby={`tab-${activeTab}`} className="py-6" data-id="element-643" data-mp="2ponpwlygk80j">
        {activeTabContent}
      </div>
    </div>;
}